export default "__VITE_ASSET__CXauBnTM__"